/* eslint-disable @typescript-eslint/no-unused-vars */
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => createStyles({
  header: {
    width: '100%',
    // position: 'fixed',
    zIndex: theme.zIndex.appBar,
    // background: `linear-gradient(180deg,${theme.palette.primary.main}, transparent)`,
    background: theme.palette.primary.main,
    '& > .MuiContainer-root': {
      display: 'flex',
      justifyContent: 'start',
      flexDirectiopn: 'row',
    },
  },
  logo: {
    width: '30%',
    [theme.breakpoints.up('sm')]: {
      width: '40%',
    },
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },
  navbar: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  menu: {
    [theme.breakpoints.between(
      theme.breakpoints.values.xs,
      theme.breakpoints.values.md,
    )]: {
      display: 'none',
    },
  },
  menuMobile: {
    [theme.breakpoints.between(
      theme.breakpoints.values.md,
      theme.breakpoints.values.xl,
    )]: {
      display: 'none',
    },
  },
  main: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  mainSection: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '&:first-child': {
      marginTop: 0,
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
}));

export default useStyles;